import React from "react";
import loginBg from "../../assets/images/login-bg.png";
import px1shadow from "../../assets/images/px1-shadow.png";
import RecoveryForm from "../../components/auth/RecoveryForm";

export default function RecoveryPage() {
  return (
    <div>
      <div className="grid lg:grid-cols-2 ">
        <RecoveryForm/>
        <div
          className="hidden lg:block h-navbar bg-cover"
          style={{ backgroundImage: `url(${loginBg})` }}
        >
          <div className="grid h-navbar place-items-center ">
            <img src={px1shadow} className="z-10" alt=""/>
          </div>
        </div>
      </div>
    </div>
  );
}
